"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ChevronDown32PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/ChevronDown32PxOutlined"));
var _ChevronDown24PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/ChevronDown24PxOutlined"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _accordionModule = _interopRequireDefault(require("./accordion.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "children", "className", "animated", "animationDuration", "onStateChange", "size", "instanceName", "responsive"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var propTypes = {
  /** Text (or markup) to show as the title for this accordion */
  label: _propTypes["default"].node.isRequired,
  /** Contents of the accordion */
  children: _propTypes["default"].node.isRequired,
  /** Animate the toggling of the accordion if true */
  animated: _propTypes["default"].bool,
  /** Customise animation duration */
  animationDuration: _propTypes["default"].number,
  /** Callback to run on open or close */
  onStateChange: _propTypes["default"].func,
  /** Set the accordion size */
  size: _propTypes["default"].oneOf(['S', 'M', 'L']),
  /** Specific namespace for open/close events */
  instanceName: _propTypes["default"].string,
  /** Class name for styling */
  className: _propTypes["default"].string,
  /** Override for size that instead adds responsive size */
  responsive: _propTypes["default"].bool
};
var Accordion = function Accordion(_ref) {
  var label = _ref.label,
    children = _ref.children,
    className = _ref.className,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? false : _ref$animated,
    _ref$animationDuratio = _ref.animationDuration,
    animationDuration = _ref$animationDuratio === void 0 ? 400 : _ref$animationDuratio,
    _ref$onStateChange = _ref.onStateChange,
    onStateChange = _ref$onStateChange === void 0 ? function () {} : _ref$onStateChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'L' : _ref$size,
    instanceName = _ref.instanceName,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    props = _objectWithoutProperties(_ref, _excluded);
  var detailsRef = (0, _react.useRef)();
  var contentRef = (0, _react.useRef)();
  var summaryRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    animation = _useState2[0],
    setAnimation = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isClosing = _useState4[0],
    setIsClosing = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isExpanding = _useState6[0],
    setIsExpanding = _useState6[1];
  var _useState7 = (0, _react.useState)(animated),
    _useState8 = _slicedToArray(_useState7, 2),
    isAnimated = _useState8[0],
    setIsAnimated = _useState8[1];
  var animationOptions = {
    duration: animationDuration,
    easing: 'ease-out'
  };
  var handleAnimatedFinished = (0, _react.useCallback)(function (open) {
    var $detail = detailsRef.current;
    if ($detail) {
      $detail.open = open;
      setAnimation(null);
      setIsClosing(false);
      setIsExpanding(false);
      $detail.style.height = '';
      $detail.style.overflow = '';
    }
  }, []);
  var expand = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    var $content = contentRef.current;
    setIsExpanding(true);
    var startHeight = "".concat($detail.offsetHeight, "px");
    var endHeight = "".concat($detail.offsetHeight + $content.offsetHeight, "px");
    if (animation) {
      animation.cancel();
    }
    var runningAnimation = $detail.animate({
      height: [startHeight, endHeight]
    }, animationOptions);
    setAnimation(runningAnimation);
    runningAnimation.onfinish = function () {
      return handleAnimatedFinished(true);
    };
    runningAnimation.oncancel = function () {
      return setIsExpanding(false);
    };
  }, [animation, handleAnimatedFinished]);
  var shrink = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    var $summary = summaryRef.current;
    setIsClosing(true);
    var startHeight = "".concat($detail.offsetHeight, "px");
    var endHeight = "".concat($summary.offsetHeight, "px");
    if (animation) {
      animation.cancel();
    }
    var runningAnimation = $detail.animate({
      height: [startHeight, endHeight]
    }, animationOptions);
    setAnimation(runningAnimation);
    runningAnimation.onfinish = function () {
      return handleAnimatedFinished(false);
    };
    runningAnimation.oncancel = function () {
      return setIsClosing(false);
    };
  }, [animation, handleAnimatedFinished]);
  var open = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    $detail.style.height = "".concat($detail.offsetHeight, "px");
    $detail.open = true;
    window.requestAnimationFrame(function () {
      return expand();
    });
  }, [expand]);
  var handleClick = (0, _react.useCallback)(function (e) {
    var $detail = detailsRef.current;
    e.preventDefault();
    $detail.style.overflow = 'hidden';
    if (isClosing || !$detail.open) {
      isAnimated ? open() : $detail.open = true;
      onStateChange(true);
    } else if (isExpanding || $detail.open) {
      isAnimated ? shrink() : $detail.open = false;
      onStateChange(false);
    }
  }, [open, shrink, onStateChange, isClosing, isExpanding, isAnimated]);
  var handleCustomEvent = (0, _react.useCallback)(function (event) {
    var _event$detail, _event$detail2;
    var $detail = detailsRef.current;
    if ((event === null || event === void 0 || (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.action) === 'open' && (isClosing || !$detail.open)) {
      isAnimated ? open() : $detail.open = true;
      onStateChange(true);
    } else if ((event === null || event === void 0 || (_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : _event$detail2.action) === 'close' && (isExpanding || $detail.open)) {
      isAnimated ? shrink() : $detail.open = false;
      onStateChange(false);
    }
  }, [open, shrink, onStateChange, isClosing, isExpanding, isAnimated]);
  (0, _react.useEffect)(function () {
    var $detail = detailsRef.current;
    if ($detail) {
      setIsAnimated(isAnimated && 'animate' in $detail);
    }
    if (instanceName) {
      document.body.addEventListener("jlds:accordion:".concat(instanceName), handleCustomEvent);
      return function () {
        document.body.removeEventListener("jlds:accordion:".concat(instanceName), handleCustomEvent);
      };
    }
  }, [instanceName, handleCustomEvent, isAnimated]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("details", _objectSpread(_objectSpread({
    ref: detailsRef,
    className: (0, _classnames["default"])(_accordionModule["default"]['c-accordion'], className, _defineProperty(_defineProperty(_defineProperty({}, _accordionModule["default"]['c-accordion--small-size'], size === 'S' && !responsive), _accordionModule["default"]['c-accordion--medium-size'], size === 'M' && !responsive), _accordionModule["default"]['c-accordion--responsive-size'], responsive)),
    "data-testid": "accordion:details"
  }, props), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("summary", {
      ref: summaryRef,
      onClick: handleClick,
      role: "button",
      tabIndex: "0",
      className: (0, _classnames["default"])(_accordionModule["default"]['c-accordion__label'], _defineProperty(_defineProperty(_defineProperty({}, _accordionModule["default"]['c-accordion__label--medium-size'], size === 'M' && !responsive), _accordionModule["default"]['c-accordion__label--small-size'], size === 'S' && !responsive), _accordionModule["default"]['c-accordion__label--responsive-size'], responsive)),
      children: [label, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames["default"])(_accordionModule["default"]['c-accordion__chevron'], _defineProperty(_defineProperty(_defineProperty({}, _accordionModule["default"]['c-accordion__chevron--medium-size'], size === 'M' && !responsive), _accordionModule["default"]['c-accordion__chevron--small-size'], size === 'S' && !responsive), _accordionModule["default"]['c-accordion__chevron--responsive-size'], responsive)),
        children: responsive ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown24PxOutlined["default"], {
            className: _accordionModule["default"]['c-accordion--small-icon']
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown32PxOutlined["default"], {
            className: _accordionModule["default"]['c-accordion--large-icon']
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [size === 'S' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown24PxOutlined["default"], {}), size === 'M' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown24PxOutlined["default"], {}), size === 'L' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown32PxOutlined["default"], {})]
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _accordionModule["default"]['c-accordion__content'],
      ref: contentRef,
      children: children
    })]
  }));
};
Accordion.propTypes = propTypes;
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Accordion);